enum HeaderUiConstantsMobileMenuOptionsMainMenu {
  'main' = 'main',
  'browse' = 'browse',
  'about' = 'about',
  'sell' = 'sell',
  'dashboard' = 'dashboard',
}

enum HeaderUiConstantsMobileMenuOptionsBrowseMenu {
  'browseMain' = 'browseMain',
  'status' = 'status',
  'brand' = 'brand',
  'countries' = 'countries',
  'topics' = 'topics',
}

enum HeaderUiConstantsMobileMenuOptionsDashboardMenu {
  'dashboardMain' = 'dashboardMain',
  'settings' = 'settings',
  'language' = 'language',
}

enum IndexNavItemChildrenTypeEnum {
  'translate' = 'translate',
  'notranslate' = 'notranslate',
}

export {
  HeaderUiConstantsMobileMenuOptionsMainMenu,
  HeaderUiConstantsMobileMenuOptionsBrowseMenu,
  HeaderUiConstantsMobileMenuOptionsDashboardMenu,
  IndexNavItemChildrenTypeEnum,
};
